import { CoreIcon } from '../core-icon';
import cardSVG from '../../assets/icons/card.svg';
import type { IconProps } from '../core-icon';

export const CardIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={cardSVG} {...props} />;
};
